// wasm-utils.ts
import init from "./rust_wassm_fetch";

let inited = false;
let initPromise: Promise<void> | null = null;

export async function initializeWasm() {
    if (inited) {
        console.warn("Wasm already inited. skip initialize.");
        return;
    }
    if(!initPromise) {
        initPromise = (async () => {
            console.log("Initializing wasm...");
            
            await init();  // 실제 WebAssembly init
            
            inited = true;

            console.log("Initializing wasm done");
        })();
    } else {
        // initPromise는 있지만, 아직 끝나지 않은 상태
        console.log("Wasm init is in progress. Waiting...");
    }
    await initPromise; 
}

export async function getInitializeWasmStatus() {
    return inited;
}